import * as yup from 'yup';

export const documentStatusChangeSchema = yup.object().shape({
  documentStatus: yup
    .number()
    .typeError('Status dokumenta je obavezno polje')
    .required('Status dokumenta je obavezno polje'),
  documentComment: yup.string().max(4000, 'Polje "Komentar" mora imati manje od 4000 karaktera.'),
});
